export const ClubsConstants = {
  ALL_CLUBS: "All Clubs",
  CHECKED_IN: "Checked In",
  APPROACHING: "Approaching",
  OVERDUE: "Overdue"
};
